/* eslint-disable max-lines-per-function */
/* eslint-disable no-empty */

import { Flex, Text } from '@chakra-ui/react'
import { FlexRow } from '@components'
import type { FC } from 'react'
// import { SavingStatisticsLegend } from './SavingStatisticsLegend'
import { DashboardCard } from '../../../../../dashboard/presentation/components/DashboardCard'
import { WeekdaysGraph } from './WeekdaysGraph'

export const WeekdaysCard: FC<{ graphData: any; title?: string; width?: string }> = ({ graphData, title, width }) => {
  return (
    <DashboardCard width={width ?? '800px'} display='flex' flexDirection='column'>
      <Flex
        flexDirection={{ base: 'column', md: 'row' }}
        width='100%'
        marginBottom={4}
        alignItems={'flex-start'}
        flexWrap={{ md: 'wrap', lg: 'nowrap' }}
      >
        {title && (
          <FlexRow alignItems={'center'} marginBottom={{ base: 2, lg: 0 }} marginTop={{ lg: 1.5 }}>
            <Text fontSize={18} fontWeight={600} lineHeight='30px'>
              {title}
            </Text>
          </FlexRow>
        )}
      </Flex>
      <div id='weekday-consumption-chart'>
        <WeekdaysGraph graphData={graphData} />
      </div>
    </DashboardCard>
  )
}
